<template>
    <div id = 'blood-draw-view-container' v-loading="loading"></div>
</template>

<script>
import { mapActions } from "pinia";
import { useBloodDrawStore } from '@/stores/BloodDrawStore.ts';
import { useCommonStore } from "@/stores/CommonStore.ts";
import { ElNotification } from "element-plus";
export default{
    async mounted(){
        this.loading=true;
        try{
            //comment for staging test: more convenient to track the redirect link's data;
            console.log('BloodDrawView link', this.$route.query);

            // Check whether has query params. 
            // If so, set top bar, store query params, fetch needed data from graphQL, and redirect to /informationLanding
            // NOTES: If no query params, means INVALID access request, such as directly typing URL
            if(this.$route.query && Object.keys(this.$route.query).length > 0){
                // 1. save query info in localStorage: for user refresh on /bloodDrawLanding
                localStorage.setItem('pns_single_page_query', JSON.stringify(this.$route.query));

                //set data in CommonStore: for the top header information
                this.setAccessionId(this.$route.query.accession_id);
                this.setSampleId(this.$route.query.sample_id);
                this.setJwtToken(this.$route.query.token);
                
                //set data in BloodDrawStore: for related apis after redirect to /bloodDrawLanding
                // NOTES: need to use await, since storeAllQueryInfomation might throw Error
                await this.storeAllQueryInfomation(this.$route.query);
                
                this.$router.push('/bloodDrawLanding');
            }else{
                //remove previous query info in localStorage: in case there is a previous record there
                localStorage.removeItem('pns_single_page_query');
                ElNotification({
                    title: 'Error',
                    type: 'error',
                    customClass: "errorNotification",
                    message: 'No query information found.',
                    duration: 0,
                });
                this.$router.push('/failed');
            }
        }catch(err){
            console.log('BloodDrawMedia mounted error: ', err);
            ElNotification({
                title: 'Failed',
                type: 'error',
                customClass: "errorNotification",
                message: err?.message ?? 'BloodDrawMedia mounted error.',
                duration: 0,
            });
            this.$router.push('/failed');
        }finally{
            this.loading=false;
        }
    },
    data(){
        return{
            loading:false
        }
    },
    methods:{
        ...mapActions(()=>useBloodDrawStore(),[
            'storeAllQueryInfomation',
        ]),
        ...mapActions(()=>useCommonStore(),[
            'setAccessionId',
            'setSampleId',
            'setJwtToken'
        ]),
    }
}
</script>

<style scoped>
#blood-draw-view-container{
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 30px;

    /*need to explicitly set parent div for children div height to be dynamic*/ 
    height:calc(100vh - 92px);
}
@media only screen and (max-width: 767px){
    #blood-draw-view-container{
        padding-left: 28px;
        padding-right: 27px;
        margin-top: 40px;

        height:fit-content;
        min-height: calc(100vh - 80px);
    }
}
</style>